import { formatCurrency } from "./prices";

export const formatCurrencyToInput = (value?: string | number) => {
  if (!value || Number.isNaN(Number(value))) return formatCurrency(0, undefined, false);

  return formatCurrency(Number(value).toFixed(2), undefined, false);
};
